import React from "react";

import { Loader2Icon } from "lucide-react";

import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { Label } from "~/components/ui/label";
import { Textarea } from "~/components/ui/textarea";
import { Profile } from "~/pages/admin/types";

interface DeactivateUserDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  profile: Profile | null;
  reason: string;
  onReasonChange: (reason: string) => void;
  onConfirm: () => Promise<void>;
  isDeactivating: boolean;
}

export const DeactivateUserDialog: React.FC<DeactivateUserDialogProps> = ({
  isOpen,
  onOpenChange,
  profile,
  reason,
  onReasonChange,
  onConfirm,
  isDeactivating,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Desactivar Usuario</DialogTitle>
          <DialogDescription>
            ¿Estás seguro que deseas desactivar al usuario{" "}
            <strong>
              {profile?.name} {profile?.lastname}
            </strong>
            ? El usuario perderá el acceso al sistema hasta que sea reactivado.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          <Label htmlFor="deactivation-reason">
            Motivo de desactivación (opcional)
          </Label>
          <Textarea
            id="deactivation-reason"
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            placeholder="Describe el motivo de la desactivación…"
            rows={3}
            disabled={isDeactivating}
          />
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isDeactivating}
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeactivating}
          >
            {isDeactivating ? (
              <>
                <Loader2Icon className="mr-2 h-4 w-4 animate-spin" />
                Desactivando...
              </>
            ) : (
              "Desactivar"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
